// extracted by mini-css-extract-plugin
export default {"main":"HomeSubsection_main__cvVin","homeBox":"HomeSubsection_homeBox__zC0vc","textBox":"HomeSubsection_textBox__biOwG","imageBox":"HomeSubsection_imageBox__oYVAp"};